<template>
    <div>
        <details v-if="!topLevel">
            <summary class="mb-0 mt-3">
                <span>
                    <span class="font-weight-bold">{{ section.title }}</span>
                    <span v-if="section.hasOwnProperty('notApplicable') && edit">
                        <input
                            type="checkbox"
                            :id="`${section.name}`"
                            v-model="section.notApplicable"
                        />
                        <span>Not applicable</span>
                    </span>
                </span>
            </summary>
            <hr
                style="width:100%;margin:auto;color:#c3c3c3;background: #c3c3c3; height: 1px; margin-bottom: 1rem;"
            />
            <div v-if="!notApplicable" v-for="f in section.fields">
                <multi-field
                    v-if="f.enabled"
                    :patient-data="patientData"
                    :edit="edit"
                    :field="f"
                    @set-value="setValue(f, $event)"
                    :patient-id="patientId"
                ></multi-field>
                <list-field
                    v-if="f.hasOwnProperty('listTitle')"
                    :patient-data="patientData"
                    :edit="edit"
                    :field="f"
                    @list-add="listAdd(f, $event)"
                    :patient-id="patientId"
                ></list-field>
            </div>
            <list-field
                v-if="section.hasOwnProperty('listTitle')"
                :patient-data="patientData"
                :edit="edit"
                :field="section"
                @list-add="listAdd(section, $event)"
                :patient-id="patientId"
            ></list-field>
            <section-field
                v-for="s in section.sections"
                :patient-data="patientData"
                :key="s.name"
                :edit="edit"
                :section="s"
                :patient-id="patientId"
            ></section-field>
        </details>
        <div v-else="">
            <p class="font-weight-bold text-uppercase mb-0">{{ section.title }}</p>
            <hr
                style="width:100%;margin:auto;color:#c3c3c3;background: #c3c3c3; height: 1px; margin-bottom: 1rem;"
            />
            <div v-if="!notApplicable" v-for="f in section.fields">
                <multi-field
                    v-if="f.enabled"
                    :patient-data="patientData"
                    :edit="edit"
                    :field="f"
                    @set-value="setValue(f, $event)"
                    :patient-id="patientId"
                ></multi-field>
                <list-field
                    v-if="f.hasOwnProperty('listTitle')"
                    :patient-data="patientData"
                    :edit="edit"
                    :field="f"
                    @list-add="listAdd(f, $event)"
                ></list-field>
            </div>
            <list-field
                v-if="section.hasOwnProperty('listTitle')"
                :patient-data="patientData"
                :edit="edit"
                :field="section"
                @list-add="listAdd(section, $event)"
            ></list-field>
            <section-field
                v-for="s in section.sections"
                :patient-data="patientData"
                :key="s.name"
                :edit="edit"
                :section="s"
                :patient-id="patientId"
            ></section-field>
        </div>
    </div>
</template>
<script>
import MultiField from "./MultiField";
import ListField from "./ListField";
import SectionField from "./SectionField";
export default {
    name: "SectionField",
    props: ["section", "notApplicable", "edit", "patientData", "topLevel", "patientId"],
    components: {
        MultiField,
        ListField,
        SectionField,
    },
    methods: {
        setValue(field, event) {
            if (field.type === "checkbox") {
                if (!field.value) {
                    field.value = [];
                }
                //@todo: check if the value is already in the array, if to pop it.
                field.value.push(event);
            } else {
                field.value = event;
            }
        },
        listAdd(sectionOrField, event) {
            if (!sectionOrField.list) {
                sectionOrField.list = [];
            }
            sectionOrField.list.push(event);
        },
    },
};
</script>
